import { createAction } from 'typesafe-actions';
import * as BOOKING from '../constants/Booking';

// GET_BOOKING_LIST

export const getBookingListAction = createAction(
    BOOKING.GET_BOOKING_LIST,
    (resolve) => () => resolve()
);

export const getBookingListCancelledAction = createAction(
    BOOKING.GET_BOOKING_LIST_CANCELLED,
    (resolve) => () => resolve()
);

export const getBookingListFulfilledAction = createAction(
    BOOKING.GET_BOOKING_LIST_FULFILLED,
    (resolve) => (categories, itemsByCategory, bannerUrl, loginRequried, shopIcon, description, grade_available, customizedFields) => resolve({ categories, itemsByCategory, bannerUrl, loginRequried, shopIcon, description, grade_available, customizedFields })
);

export const getBookingListRejectedAction = createAction(
    BOOKING.GET_BOOKING_LIST_REJECTED,
    (resolve) => (error) => resolve({ error })
);

// GET_AVAILABLE_TIMESLOT

export const getAvailableTimeslotsAction = createAction(
    BOOKING.GET_AVAILABLE_TIMESLOTS,
    (resolve) => () => resolve()
);

export const getAvailableTimeslotsCancelledAction = createAction(
    BOOKING.GET_AVAILABLE_TIMESLOTS_CANCELLED,
    (resolve) => () => resolve()
);

export const getAvailableTimeslotsFulfilledAction = createAction(
    BOOKING.GET_AVAILABLE_TIMESLOTS_FULFILLED,
    (resolve) => (timeslots, params) => resolve({ timeslots, params })
);

export const getAvailableTimeslotsRejectedAction = createAction(
    BOOKING.GET_AVAILABLE_TIMESLOTS_REJECTED,
    (resolve) => (error, params) => resolve({ error, params })
);

// GET_TIMESLOT_GROUP

export const getTimeslotGroupAction = createAction(
    BOOKING.GET_TIMESLOT_GROUP,
    (resolve) => () => resolve()
);

export const getTimeslotGroupCancelledAction = createAction(
    BOOKING.GET_TIMESLOT_GROUP_CANCELLED,
    (resolve) => () => resolve()
);

export const getTimeslotGroupFulfilledAction = createAction(
    BOOKING.GET_TIMESLOT_GROUP_FULFILLED,
    (resolve) => (timeslotGroupData) => resolve({ timeslotGroupData })
);

export const getTimeslotGroupRejectedAction = createAction(
    BOOKING.GET_TIMESLOT_GROUP_REJECTED,
    (resolve) => (error) => resolve({ error })
);

// SUBMIT_BOOKING

export const submitBookingAction = createAction(
    BOOKING.SUBMIT_BOOKING,
    (resolve) => (params) => resolve(params)
);

export const submitBookingCancelledAction = createAction(
    BOOKING.SUBMIT_BOOKING_CANCELLED,
    (resolve) => () => resolve()
);

export const submitBookingFulfilledAction = createAction(
    BOOKING.SUBMIT_BOOKING_FULFILLED,
    (resolve) => (record) => resolve({ record })
);

export const submitBookingRejectedAction = createAction(
    BOOKING.SUBMIT_BOOKING_REJECTED,
    (resolve) => (error, message) => resolve({ error, message })
);

// GET_RECORD_LIST

export const getRecordListAction = createAction(
    BOOKING.GET_RECORD_LIST,
    (resolve) => (phone) => resolve({ phone })
);

export const getRecordListCancelledAction = createAction(
    BOOKING.GET_RECORD_LIST_CANCELLED,
    (resolve) => () => resolve()
);

export const getRecordListFulfilledAction = createAction(
    BOOKING.GET_RECORD_LIST_FULFILLED,
    (resolve) => (all, pending, success, fail, checkedIn, phone) => resolve({ all, pending, success, fail, checkedIn, phone })
);

export const getRecordListRejectedAction = createAction(
    BOOKING.GET_RECORD_LIST_REJECTED,
    (resolve) => (error) => resolve({ error })
);

// GET_RECORD_DETAIL

export const getRecordDetailAction = createAction(
    BOOKING.GET_RECORD_DETAIL,
    (resolve) => () => resolve()
);

export const getRecordDetailCancelledAction = createAction(
    BOOKING.GET_RECORD_DETAIL_CANCELLED,
    (resolve) => () => resolve()
);

export const getRecordDetailFulfilledAction = createAction(
    BOOKING.GET_RECORD_DETAIL_FULFILLED,
    (resolve) => () => resolve()
);

export const getRecordDetailRejectedAction = createAction(
    BOOKING.GET_RECORD_DETAIL_REJECTED,
    (resolve) => (error) => resolve({ error })
);

export const selectBookingItemAction = createAction(
    BOOKING.SELECT_BOOKING_ITEM,
    (resolve) => (bookingItem) => resolve({ bookingItem })
)

export const deselectBookingItemAction = createAction(
    BOOKING.DESELECT_BOOKING_ITEM,
    (resolve) => () => resolve()
)

export const updateBookingFormAction = createAction(
    BOOKING.UPDATE_BOOKING_FORM,
    (resolve) => (form) => resolve({ form })
)

export const fixBookingFormAction = createAction(
    BOOKING.FIX_BOOKING_FORM,
    (resolve) => (form) => resolve({ form })
)

// `preselect` is the date / branch the form opened with, null once the pre-select is done or dropped
export const setTimeslotPreselectAction = createAction(
    BOOKING.SET_TIMESLOT_PRESELECT,
    (resolve) => (preselect) => resolve({ preselect })
)

export const updateAvailablePeople = createAction(
    BOOKING.UPDATE_AVAILABLE_PEOPLE,
    (resolve) => (availableNumberOfPeople) => resolve({ availableNumberOfPeople })
)

export const notAvailableDateAction = createAction(
    BOOKING.NOT_AVAILABLE_DATE,
    (resolve) => () => resolve()
)

export const resetBookingAction = createAction(
    BOOKING.RESET_BOOKING,
    (resolve) => () => resolve()
)